import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import CmnActionButtons from "../shared/cmnActionButtons";
import FacilityInfoTab from "./facilityInfoTab";
import PendingCmnsTab from "./pendingCmnsTab";
import AssociatedProvidersTab from "./associatedProvidersTab";

/**
 * Facility Dashboard — shown inside PopupModal when a facility is selected.
 * Contains:
 *  - Persistent action buttons (Download CMNs, Send via DocuSign, Send via Fax)
 *  - 3 sub-tabs: Facility Information | Pending CMNs | Associated Providers
 */
function FacilityDashboard({ facilityId, facilityName }) {
  return (
    <div className="cmn-dashboard">
      <CmnActionButtons contextType="facility" contextId={facilityId} />
      <Tabs defaultActiveKey="facilityInfo" id={`facility-dashboard-tabs-${facilityId}`} className="mb-2 cmn-dashboard-tabs">
        <Tab eventKey="facilityInfo" title="Facility Information">
          <FacilityInfoTab facilityId={facilityId} />
        </Tab>
        <Tab eventKey="pendingCmns" title="Pending CMNs">
          <PendingCmnsTab facilityId={facilityId} physicianId={0} />
        </Tab>
        <Tab eventKey="associatedProviders" title="Associated Providers">
          <AssociatedProvidersTab facilityId={facilityId} facilityName={facilityName} />
        </Tab>
      </Tabs>
    </div>
  );
}

export default FacilityDashboard;
